// Security settings API - per-tenant org_security_settings.
// G360_K580 - adds the page read (security_board), the enforced sign-in
// policy save (save_security_policy) and the signed-in person's check
// (my_security_check), all from migration 0310. getSecuritySettings is
// kept: the session timeout falls back to it before 0310 is run.
import { supabase } from '@govern360/shared';

export function isMissingFn(error) {
  return !!error && (error.code === 'PGRST202' || error.code === '42883' || /could not find the function/i.test(error.message || ''));
}

export async function getSecuritySettings(tenantId) {
  const { data, error } = await supabase
    .from('org_security_settings').select('*').eq('tenant_id', tenantId).maybeSingle();
  if (error) return { data: null, error };
  // sane defaults if no row yet
  return {
    data: data || { tenant_id: tenantId, require_mfa: false, session_timeout_min: 1440, ip_allowlist: [], sso_enabled: false },
    error: null,
  };
}

export async function saveSecuritySettings(tenantId, s) {
  const { data, error } = await supabase.rpc('save_security_settings', {
    p_tenant_id: tenantId,
    p_require_mfa: !!s.require_mfa,
    p_session_timeout_min: s.session_timeout_min,
    p_ip_allowlist: s.ip_allowlist || [],
    p_sso_enabled: !!s.sso_enabled,
  });
  if (error) return { ok: false, error: error.message };
  return data || { ok: false, error: 'No response' };
}

export async function readBoard(tid) {
  try {
    const { data, error } = await supabase.rpc('security_board', { p_tenant: tid });
    if (error) return { data: null, error, missing: isMissingFn(error) };
    return { data, error: null, missing: false };
  } catch (e) { return { data: null, error: e, missing: false }; }
}

export async function savePolicy(tid, p) {
  const { data, error } = await supabase.rpc('save_security_policy', { p_tenant: tid, p });
  if (error) return { ok: false, error: error.message || 'the save failed' };
  return data || { ok: false, error: 'No response' };
}

/* The signed-in person under their organisation's policy. null when it
   could not be asked (not run yet, offline): the caller then keeps the
   plain idle timeout - an outage never signs anyone out. */
export async function myCheck(tid) {
  try {
    const { data, error } = await supabase.rpc('my_security_check', { p_tenant: tid });
    if (error || !data) return null;
    return data;
  } catch (e) { return null; }
}
